import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';
import Box from './Box';

var Container = _styled("ul", {
  target: "erpzkha0"
})(process.env.NODE_ENV === "production" ? {
  name: "14q7rqj",
  styles: "padding:0;display:flex;justify-content:stretch;"
} : {
  name: "14q7rqj",
  styles: "padding:0;display:flex;justify-content:stretch;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var Tabs =
/*#__PURE__*/
function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tabs)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      activeTab: _this.props.children[0].props.label
    };

    _this.onClickTabItem = function (tab) {
      _this.setState({
        activeTab: tab
      });
    };

    return _this;
  }

  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var onClickTabItem = this.onClickTabItem,
          _this$props = this.props,
          children = _this$props.children,
          fullWidth = _this$props.fullWidth,
          restProps = _objectWithoutProperties(_this$props, ["children", "fullWidth"]),
          activeTab = this.state.activeTab;

      return React.createElement(Box, restProps, React.createElement(Container, null, children.map(function (child) {
        var _child$props = child.props,
            label = _child$props.label,
            tabIcon = _child$props.tabIcon;
        return React.createElement(Tab, {
          activeTab: activeTab,
          key: label,
          label: label,
          onClick: onClickTabItem,
          tabIcon: tabIcon,
          fullWidth: fullWidth
        });
      })), React.createElement("div", null, children.map(function (child) {
        return child.props.label === activeTab ? child : undefined;
      })));
    }
  }]);

  return Tabs;
}(Component);

export default Tabs;